import Vue from 'vue'
import Vuex from 'vuex'
import store from './vuex/store';
import { mapMutations } from 'vuex';
import App from './App.vue'
import router from './router'
import urls from '@/helpers/urls'
import blob from '@/helpers/blob'
import MixinsUtils from '@/helpers/utils'
import moment from 'moment'
import 'moment/dist/locale/pt-br';

//plugins
import "@/plugins/axios";
import "@/plugins/bootstrap";
import "@/plugins/elementUi";
import "@/plugins/vMoney";
import "@/plugins/fontAwesome";
import "@/plugins/sentry";
import "@/plugins/apexChart";
import 'select2'
import 'select2/dist/css/select2.min.css'
import 'element-ui/lib/theme-chalk/display.css'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

// components
import CustomSelectSingle from '@/components/shared/CustomSelectSingle.vue';
import CustomSelectMultiple from '@/components/shared/CustomSelectMultiple.vue';

//diretivas
import directives from '@/helpers/directives'
import { VMoney } from 'v-money'
import { clipboard } from 'vue-clipboards'; // https://github.com/zhuowenli/vue-clipboards

// analytics
import VueGtag from "vue-gtag"; // https://matteo-gabriele.gitbook.io/vue-gtag/

Vue.use(Vuex);

const getParams = () => {
    const getUser = JSON.parse(localStorage.getItem('user')) || ''
    if(!getUser) {
        return
    }
    const dimensoes = {
        'usuario_nome': getUser.user.nome || '',
        'usuario_email': getUser.user.email || '',
        'usuario_id': getUser.user._id || '',
        'grupo_nome': getUser.customer.nome || '',
        'grupo_codigo': getUser.customer.codigo || '', 
        'grupo_id': getUser.customer._id || '',  
        'grupo_tipo_perfil': 'Franqueador',
        'grupo_marcas': getUser.customer.marcasDaFranquia.join(',') || '',
        'grupo_qtd_cli': getUser.customer.qtdeGrupos || '',
        'usuario_adm' : getUser.user.isAdmin || '',
        'usuario_pagina_inicial': window.location.href,
        'grupo_tipo_contrato': getUser.customer.contrato || ''
    }

    return dimensoes
}

Vue.use(VueGtag, {
    appName: 'Perfil franqueador - f360',
    pageTrackerScreenviewEnabled: false,
    pageTrackerTemplate(to) {
        
        gtag('event', 'custom_dimensions', getParams())

        return {
            ...getParams(),
            page_path: to.path,
            page_location: window.location.href
        }
    },
    config: { 
        id: process.env.NODE_ENV === 'development'? 'G-FVZ2XV2HT0' : 'G-MHSX30K37N',
        params: {
            usuario_nome: 'usuario_nome',
            usuario_email: 'usuario_email',
            usuario_id: 'usuario_id',
            grupo_nome: 'grupo_nome',
            grupo_codigo: 'grupo_codigo',
            grupo_id: 'grupo_id',
            grupo_tipo_perfil: 'grupo_tipo_perfil',
            grupo_marcas: 'grupo_marcas',
            grupo_qtd_cli: 'grupo_qtd_cli',
            usuario_adm: 'usuario_adm' ,
            usuario_pagina_inicial: 'usuario_pagina_inicial',
            grupo_tipo_contrato: 'grupo_tipo_contrato'
        }
    }
}, router);


Vue.config.productionTip = false
Vue.prototype.$urls = urls // add rotas de request
Vue.prototype.$blob = blob
Vue.prototype.moment = moment // add momentjs
Vue.prototype.moment.locale('pt-br');

Vue.prototype.money = {
    decimal: ',',
    thousands: '.',
    prefix: 'R$ ',
    suffix: '',
    precision: 2
}

const rotaLogin  = { path: '/', name: 'public' }
const rotaLogado = { path: '/', name: 'secure' }
const accessToken = () => {
  const local = localStorage.getItem('accessToken');
  if (!local) {
      return false;
  }

  const base = local.split('.')[1];
  let obj;

  try {
      obj = JSON.parse(window.atob(base));
  } catch (err) {
      obj = { unique_name: null };
  }

  if (obj.exp) {
      const isExpired = new Date(obj.exp * 1000) < new Date();
      if (isExpired) {
          localStorage.removeItem('accessToken');
          localStorage.removeItem('user');
          return false;
      }
  }

  return obj['unique_name'] ? local : false;
};


Vue.component('custom-select-single', CustomSelectSingle);
Vue.component('custom-select-multiple', CustomSelectMultiple);
Vue.mixin(MixinsUtils)

window.GlobalVmo = new Vue({
    router,
    store,
    render: h => h(App),
    created(){
        const isValidAccessToken = !!accessToken();
        
        if (requiresAuth(this.$route) && !isValidAccessToken) {
            router.push(rotaLogin);
            return;
        }

        // se autenticado e colocar url login, redireciona para home
        if (this.$route.name === 'public' && isValidAccessToken === true) {
            router.push(rotaLogado);
        }

        if(isValidAccessToken){
            this.setAcessosUser(JSON.parse(localStorage.getItem('user')).claims);
        }

        const self = this
        self.axios.interceptors.response.use(function (response) { // interceptador global de erro
            return response;
          }, function (error) {
            if (error.config?.suppressInterceptorError) {
              return Promise.reject(error);
            }

            if (error.response) {
                if(error.response.status == 401){
                    localStorage.removeItem('accessToken')
                    localStorage.removeItem('user')
                    router.push(rotaLogin)
                }else if(error.response.status == 500){
                    self.$message.error({
                        showClose: true,
                        message: 'Exception: algum erro no servidor',
                        type: 'error',
                        duration: 6000
                    });
                }else{
                    self.$message.error({
                        showClose: true,
                        message: error.response.data.title || error.response.data || "Ocorreu algum problema com a requisição",
                        type: 'error',
                        duration: 6000
                    });
                }
            } else {
                self.$message.error({
                    showClose: true,
                    message: 'Ocorreu algum erro com a requisição.',
                    type: 'error',
                    duration: 6000
                });
            }
            return Promise.reject(error);
        });

      // clear no style do modal ao fechar
      this.$root.$on('bv::hide::modal', (bvEvent) => {
        if(bvEvent.target){
          let modalContent = bvEvent.target.children[0].children[0]
          modalContent.removeAttribute('style')
        }
      })
    },
    directives: {
        directives,
        clipboard,
        money:VMoney
    },
    watch: {
        $route(to) { // Ao alterar url manual verifico área segura/publica 
            if (accessToken() && to.name == 'public') {
                router.push(rotaLogado)
            }
            /* const secureRoute = this.$router.options.routes.find(r => r.name === "secure").children
            const route = secureRoute.find(route => route.path === to.path)

            if (route && Array.isArray(route.children)) {
                this.children = route.children
            } else if (route) {
                this.children = []
            } */
        }
    },
    methods: {
        ...mapMutations(['setAcessosUser'])
    }
}).$mount('#app')

function requiresAuth(to) {
    let requiresAuth = ((to.matched[to.matched.length - 1].meta) || {}).requiresAuth;
  
    if (requiresAuth === undefined || requiresAuth === null) {
      return to.matched.some(record => record.meta.requiresAuth);
    }
  
    return requiresAuth;
  }

router.beforeEach((to, from, next) => {
    const isValidAccessToken = accessToken() ? true : false;
    
    if (requiresAuth(to) && !isValidAccessToken) {
        next(rotaLogin);
        return;
    }

    // se autenticado e colocar url login, redireciona para home
    if (to.name === 'public' && isValidAccessToken === true) {
      next(rotaLogado);
      return;
    }

    next();
  });
